export const defaultRenderCell = () => null;
export const defaultSizes = {
  tableWidth: 600,
  tableHeight: 400,
  rowHeight: 40,
  lowDenistyRowHeight: 52,
  highDensityRowHeight: 28,
  columnWidth: 150,
  selectionControlColumnWidth: 40,
  minimumUnfrozenColumnWidth: 100,
  minimumColumnWidth: 64,
  maximumColumnWidth: 1000,
  dropIndicatorLineHeight: 2
};

/**
 * Default values and functions used by Table and associated utilities.
 */
export const Defaults = {
  sizes: defaultSizes,
  selectionMode: 'multiple',
  getRowKey: rowIndex => rowIndex.toString(),
  renderCell: defaultRenderCell
};
//# sourceMappingURL=Defaults.js.map